<div class="justify-center items-center flex align-middle h-12 sticky top-[100vh] w-full">
	© 2023 KOgent Systems, LLC. All rights reserved.
</div>
